export const COMPARISON_CONSTANTS_NETWORK_DESIGN = {
  title: "Built to Scale: Traditional vs OneMind Network Design",
  desc: "While legacy network deployments struggle with rigidity and reactive management, OneMind delivers agile, secure, and business-aligned architectures designed for tomorrow’s demands.",
  items: [
    {
      title: "The Old Way",
      subTitle: "Legacy or Ad-Hoc Design",
      points: [
        "One-size-fits-all architecture lacking flexibility",
        "Manual deployment with long rollout times",
        "No integrated compliance or risk posture",
        "Poor visibility into network performance",
        "Reactive upgrades based on outages",
        "Limited scalability for cloud or hybrid growth",
      ],
    },
    {
      title: "The New Way",
      subTitle: "OneMind Design & Deployment",
      points: [
        "Tailored network blueprints aligned to business goals",
        "Fast, fully managed rollout across wired, wireless & cloud",
        "Security-first design with compliance baked in",
        "Real-time monitoring and performance optimization",
        "Future-ready architecture with proactive planning",
        "Modular design supports seamless growth and hybrid integrations",
      ],
    },
  ],
};
